module.exports = __webpack_public_path__ + "img/solar_equipment.e932faa3.png";